import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fromJS } from 'immutable';
import { bindActionCreators } from 'redux'

import TextInputField from '../../infra/components/formInput/CustomTextInput'
import ComboboxInput from "../../infra/components/formInput/ComboboxInput";
import ActionGetAllClient from "../../store/action/Client/FetchAll";
import ActionAdd from '../../store/action/GroupTemplate/Add'
import ActionEdit from '../../store/action/GroupTemplate/Edit'
import ActionDelete from '../../store/action/GroupTemplate/Delete'
import ActionGet from '../../store/action/GroupTemplate/Fetch'
import ActionView from '../../store/action/GroupTemplate/View'
import {toast} from "react-toastify";
import {ClientId} from "../../helper/HelperAuth";


class Page extends Component {
    constructor(props) {
        super(props)
        this.state = {
            form: fromJS({
                'group-id'  : '',
                'client-id' : '',
                'group-name' : ''
            }),
            errors: fromJS({}),
            error: '',
            status :'is-create',
            button : ''
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleDeleteClicked = this.handleDeleteClicked.bind(this);
    }
    componentDidMount() {
        this.props.actionGetAllClient()
        this.props.actionGet(1)
    }

    async handleChange(field, value, label) {
        var formVal = this.state.form;
        let button = this.state.button;
        formVal = formVal.set(field,value);
        let viewResponse = '';
        this.setState({ form:formVal })
        if (field == 'group-id') {
            if (value != "" || value != null || value != undefined) {
                viewResponse = this.props.actionView(value)
                let data = fromJS(await viewResponse);
                formVal = formVal.set('client-id', data.get('client-id'));
                formVal = formVal.set('group-name', data.get('group-name'));
                this.setState({ form:formVal })
            }

        }
    }

    async handleDeleteClicked() {
        await this.handleDeleteData()
    }

    async handleSubmit() {
        const form = this.state.form;
        let group_id = form.get('group-id')
        if(form.get('client-id') === '' || form.get('client-id') === null || form.get('client-id') === undefined){
            this.setState({error : "Client cannot be empty!"});
            toast.error("Client cannot be empty!", toast.POSITION.TOP_RIGHT);
            return false
        }

        if(form.get('group-name') === ''){
            this.setState({error : "Group name cannot be empty!"});
            toast.error("Group Name cannot be empty!", toast.POSITION.TOP_RIGHT);
            return false
        }

        if (group_id === '' || group_id === null || group_id === undefined) {
            await this.SubmitNewData();
        } else {
            await this.UpdateData();
        }
    }

    async handleDeleteData() {
        const form = this.state.form;
        var data =
            {'data' :
                    {
                        'group-id'   : form.get('group-id'),
                    }
            };

        var response = await this.props.actionDelete(data);
        if(response.ok){
            toast.success("Delete Success!", toast.POSITION.TOP_RIGHT);
        }else{
            toast.error("Delete Failed!", toast.POSITION.TOP_RIGHT);
        }
    }


    async UpdateData() {
        const form = this.state.form;
        var data =
            {'data' :
                    {
                        'group-id'   : form.get('group-id'),
                        'group-name' : form.get('group-name'),
                        'client-id'  : form.get('client-id')
                    }
            };

        var response = await this.props.actionEdit(data);
        if(response.ok){
            toast.success("Save Success!", toast.POSITION.TOP_RIGHT);
        }else{
            toast.error("Save Failed!", toast.POSITION.TOP_RIGHT);
        }
    }

    async SubmitNewData(){
        const form = this.state.form;
        var data =
            {'data' :
                    {
                        'group-name' : form.get('group-name'),
                        'client-id'  : form.get('client-id')
                    }
            };

        var response = await this.props.actionAdd(data);
        if(response.ok){
            toast.success("Save Success!", toast.POSITION.TOP_RIGHT);
        }else{
            toast.error("Save Failed!", toast.POSITION.TOP_RIGHT);
        }
    }

    render() {
        const { form } = this.state
        let group_id = form.get('group-id')
        let classHide = 'col-sm-2'
        let title = 'Update'
        if (group_id === '' || group_id === null) {
            classHide = 'col-sm-2 hidden'
            title = 'Submit'
        }

        return (
            <div className="card">
                <div className="body">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="input-group-btn">
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <ComboboxInput
                                field='group-id'
                                value={form.get('group-id')}
                                options={fromJS({
                                    'source': this.props.grouptemplate,
                                    'value': 'group-id',
                                    'label': 'group-name',
                                    'other' : 'client-id',
                                }) }
                                onChange={(field, value, label) => this.handleChange(field,value,label)}
                                placeholder="Group Template"
                            />
                        </div>
                        <div className="col-sm-12">
                            <ComboboxInput
                                field='client-id'
                                value={form.get('client-id')}
                                options={fromJS({
                                    'source': this.props.clientall,
                                    'value': 'client-id',
                                    'label': 'client-name'
                                }) }
                                onChange={(field, value, label) => this.handleChange(field,value,label)}
                                placeholder="Client"
                            />
                        </div>
                        <div className="col-sm-12">
                            <div className="input-group-btn">
                                <TextInputField className="form-control"
                                    textarea
                                    field={'group-name'}
                                    value={form.get('group-name')}
                                    onChange={(field, value) => this.handleChange(field, value)}
                                    placeholder="Group Name"
                                />
                            </div>

                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-2">
                            <div className="input-group-btn">
                                <button type="button"
                                        className="btn btn-wide btn-success"
                                        onClick={this.handleSubmit}>
                                    {title}
                                </button>
                            </div>
                        </div>
                        <div className={classHide}>
                            <div className="input-group-btn">
                                <button type="button"
                                        className="btn btn-wide btn-danger"
                                        onClick={this.handleDeleteClicked}>
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}



export default connect(
    (state) => {
        return {
            clientall: state.user.clientall,
            grouptemplate: state.user.grouptemplate,
        }
    },
    dispatch => bindActionCreators({
        actionGetAllClient:ActionGetAllClient,
        actionAdd: ActionAdd,
        actionEdit: ActionEdit,
        actionDelete: ActionDelete,
        actionGet: ActionGet,
        actionView: ActionView,
    }, dispatch),
)(Page);